import React, { useState } from "react";
import Icon from '../../assets/images/spotlight3.png'
import { Button, Modal } from "antd";
import Avatar from '../../assets/images/avatar2.png'
import { useTranslation } from "react-i18next";
import './style.css'
import useGetOneData from "../../hooks/useGetOneData";
import LoaderComponent from "../loader";

type ICardProp = {
  data?: any
}


const ArbitratorSearchResultCard: React.FC<ICardProp> = ({ data }) => {
  const { t } = useTranslation()
  const [openModal, setopenModal] = useState<boolean>()
  const [_id, set_id] = useState<number | undefined>()

  const handleOk = () => {
    setopenModal(false);
  };

  const handleCancel = () => {
    setopenModal(false);
  };

  const { data: arbitrator_view } = useGetOneData<any>({
    queryKey: ["arbitrators", _id],
    url: `arbitrators/${_id}`,
    options: {
        enabled: !!_id
    }
})


  return (
    <>
      {
        data?.length ? data?.map((item: any) => (
          <div className='2xl:col-span-4 md:col-span-6 col-span-12 rounded-xl p-5 bg-main_color flex gap-4 text-white hover:cursor-pointer' onClick={() => {setopenModal(true); set_id(item?.id)}}>
            <div className="w-[90px] h-[90px] shrink-0 bg-white flex justify-center items-center rounded">
              <img src={Icon} alt="icon" className="w-[80%] h-[80%] mx-auto block" />
            </div>
            <div className="box-border xl:text-base text-sm overflow-hidden">
              <h3 className="whitespace-nowrap">{t('Name')} : {item?.person?.firstName}</h3>
              <h3 className="whitespace-nowrap">{t('Surname')} : {item?.person?.lastName}</h3>
              <p className="whitespace-nowrap">{t('Middle name')} : {item?.person?.middleName}</p>
              <p className="whitespace-nowrap">{t('Phone')} : {item?.person?.phone}</p>
              <p className="whitespace-nowrap">{t('Email')} : {item?.person?.user?.email}</p>
            </div>
          </div>
        )) : data?.length == 0  ? "No result" : <LoaderComponent/>
      }

      <div className="arbitrator_view">
        <Modal open={openModal} onOk={handleOk} closable={false} wrapClassName="arbitrator_view_modal" onCancel={handleCancel} centered footer>
          <div className="arbitrator_view_header pt-16">
            <img src={Avatar} alt="image" className="w-[138px] h-[138px] rounded-[50%] block text-center mx-auto" />
          </div>
          <div className="rounded-lg px-2 pb-5" style={{background:'linear-gradient(180deg, rgba(217, 217, 217, 0) 0%, rgba(28, 114, 166, 0.2) 100%)'}}>
            <h3 className="font-semibold text-base text-center my-1 text-main_color">{arbitrator_view?.person?.firstName} {arbitrator_view?.person?.lastName}</h3>
            <p className="text-main_color text-center">United Arab Emirates, Dubai</p>
            <h4 className="text-[15px] font-semibold">Legal Adviser to the Minister of Finance at UAE Ministry of Finance</h4>
            <span className="text-[#868686]">{t('Specialization')}</span>
            <p className="font-semibold">CISG, Construction, Corporate Law, Environment, Financial Derivatives, Franchise & Distribution, IP, Investment, Lease, Loan, Public–private partnership, Real Estate, Stock trading, Transaction with securities, Treaty-Based Arbitration</p>
            <span className="text-[#868686]">{t('Area')}</span>
            <p className="font-semibold">Blockchain, Construction & Development, Energy, Financial Institutions, Food & Beverage, Infrastructure, Manufacturing & Production, Media & Telecommunications, Public Procurement, Trade & Retail</p>
            <span className="text-[#868686]">{t('Language')}</span>
            <p className="font-semibold">Arabic, English</p>
            <Button className="text-center px-2 mx-auto block font-semibold text-main_color w-[198px]">{t('I GOT YOU')}</Button>
          </div>
        </Modal>
      </div>
    </>
  )
}

export default ArbitratorSearchResultCard